export default __webpack_public_path__ + "static/media/12 - Elephant Castle.99995598.jpg";